window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.loadMode = 1
window.lazySizesConfig.expFactor = 2.5
window.lazySizesConfig.init = false
import '@/plugins/logger'
import WebFontLoader from '@/plugins/webfontloader'
import Loader from '@/core/loader'
// import Router from '@/core/router'
// import routes from '@/views'
import 'lazysizes/plugins/object-fit/ls.object-fit'
import lazysizes from 'lazysizes'
import objectFitImages from 'object-fit-images'
// import links from '@/plugins/links'

if (module.hot) {
	module.hot.accept()
}

WebFontLoader()

objectFitImages(
	document.querySelectorAll(
		'img.object-contain, img.object-cover, .slide__item img'
	)
)
lazysizes.init()

const app = new Loader(document)
const $container = document.getElementById('barba-wrapper')

// document for first mount call
let root = document

// const $devToolbar = document.getElementById('yii-debug-toolbar') || null;

// if ($container) {
// 	new Router({
// 		routes,
// 		transitionOnLoad: true,
// 		onChange: [],
// 		onEnter: [
// 			() => {
// 				app.mount(root)
// 				root = $container
// 			}
// 		],
// 		onLeave: [app.unmount],
// 		onReady: [],
// 		onComplete: [
// 			() => {
// 				links()
// 			}
// 		],
// 		navigation: ['header nav', 'body > nav'],
// 		currentClass: 'is-current',
// 		currentParentClass: 'is-current-parent'
// 	}).start()
// } else {
	app.mount()
// }
